import type { IRequest } from '../../../../../common/interfaces/IRequest';
import { CardTheme, FixedCard } from '../../../elements/molecules/card/Card';
import { onDownloadReferralLetter } from '../utils';

type OsasFlexJouwVerwijzingCardProps = {
    request?: IRequest;
    userHasOsasMraReferralLetter?: boolean;
};

export function OsasFlexJouwVerwijzingCard(props: Readonly<OsasFlexJouwVerwijzingCardProps>) {
    const { userHasOsasMraReferralLetter } = props;
    const requestId = props.request?.id;

    return (
        <FixedCard
            body={
                'Download je brief en neem deze mee naar de afspraak met de tandarts. Je krijgt dan de beugel vergoed.'
            }
            buttonsText={['Download je brief']}
            cardTitle={'Jouw brief met diagnose'}
            icon={'download'}
            onClick={() => onDownloadReferralLetter(requestId, userHasOsasMraReferralLetter)}
            theme={CardTheme.white}
        />
    );
}
